import cloneDeep from "lodash.clonedeep";
import find from "lodash.find";

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const inputChangeHandler = (e, setFormValues) => {
  let inputName = e.target.name;
  let inputValue = "";

  if (e.target.type == "checkbox" && inputName == "Permission") {
    inputValue = e.target.checked;
    let value =
      e.target.value != "" &&
      e.target.value != null &&
      e.target.value != undefined &&
      typeof e.target.value == "string"
        ? e.target.value.trim()
        : e.target.value;

    setFormValues((prevState) => {
      var currentObj = cloneDeep(prevState);
      let valueArr = currentObj[inputName].value;
      if (!valueArr.includes(value)) {
        //checking weather array contain the id
        valueArr.push(value); //adding to array because value doesnt exists
      } else {
        valueArr.splice(valueArr.indexOf(value), 1); //deleting
      }
      currentObj[inputName].value = valueArr;
      currentObj[inputName].touched = true;
      currentObj[inputName].error = valueArr.length > 0 ? false : true;

      return currentObj;
    });
  } else if (e.target.type == "checkbox") {
    inputValue = e.target.checked;
    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
        touched: true,
        error: !inputValue,
        message: inputValue ? "" : prevState[inputName]["default_msg"],
      },
    }));
  } else {
    inputValue =
      e.target.value != undefined &&
      e.target.value != null &&
      e.target.value != ""
        ? e.target.value
        : "";

    setFormValues((prevState) => ({
      ...prevState,
      [inputName]: {
        ...prevState[inputName],
        value: inputValue,
        error: false,
        message: inputValue ? "" : prevState[inputName]["default_msg"],
      },
    }));
  }
};
export const checkAllRequiredFieldsFilled = (formValues, setContinueEnable) => {
  var validate = true;
  for (var k in formValues) {
    var info = formValues[k];
    if (Array.isArray(info)) {
      // Validate Child Fields
      var subFieldValid = true;
      for (var n = 0; n < info.length; n++) {
        for (var s in info[n]) {
          var subFiledInfo = info[n][s];
          if (
            subFiledInfo.required == true &&
            (subFiledInfo.value == "" ||
              subFiledInfo.value == null ||
              subFiledInfo.value == false ||
              subFiledInfo.error == true)
          ) {
            subFieldValid = false;
            validate = false;
            break;
          }
        }
        if (!subFieldValid) {
          break;
        }
      }
      if (!subFieldValid) {
        break;
      }
    } else {
      if (
        info.required == true &&
        (info.value == "" ||
          info.value == null ||
          info.value == false ||
          info.error == true)
      ) {
        validate = false;
        break;
      }
    }
  }
  setContinueEnable(validate);
};

export const checkStepRequiredFieldsFilled = (formValues) => {
  var validate = true;

  if (Array.isArray(formValues)) {
    formValues = arrayToObject(formValues);
  }
  //console.log("checkStepRequiredFieldsFilled - formValues:", formValues);

  for (var k in formValues) {
    var info = formValues[k];
    if (Array.isArray(info)) {
      // Validate Child Fields
      var subFieldValid = true;
      for (var n = 0; n < info.length; n++) {
        for (var s in info[n]) {
          var subFiledInfo = info[n][s];
          if (
            subFiledInfo.required == true &&
            (subFiledInfo.value == "" ||
              subFiledInfo.value == null ||
              subFiledInfo.value == false ||
              subFiledInfo.error == true)
          ) {
            subFieldValid = false;
            validate = false;
            break;
          }
        }
        if (!subFieldValid) {
          break;
        }
      }
      if (!subFieldValid) {
        break;
      }
    } else {
      if (
        info.required == true &&
        (info.value == "" ||
          info.value == null ||
          info.value == false ||
          info.error == true)
      ) {
        validate = false;
        break;
      }
    }
  }

  return !validate;
};

function arrayToObject(array) {
  // Use the spread operator (...) to merge all objects into a single object
  return array.reduce((result, obj) => ({ ...result, ...obj }), {});
}

export const isFormValid = (
  formValues,
  setFormValues,
  specificCheck,
  extraParamsObj
) => {
  let formValueCloneObj = cloneDeep(formValues);
  //console.log("formValueCloneObj", formValueCloneObj);
  let valid = true;
  for (let key in formValues) {
    if (
      specificCheck != null &&
      specificCheck != undefined &&
      specificCheck.length > 0
    ) {
      if (!specificCheck.includes(key)) {
        continue;
      }
    }
    let validationType = formValues[key].type;
    let inputValue = formValues[key].value;
    let isRequired = formValues[key].required;
    let defaultMsg = formValues[key].default_msg;

    if (
      (key == "SeatType" && formValues[key].value == "0") ||
      (key == "RequestCompression" && formValues[key].value == "0") ||
      key == "FloorRange" ||
      (key == "QPSOptimization" && formValues[key].value == "0") ||
      (key == "target_skippable" && formValues[key].value == "0") ||
      (key == "target_app" && formValues[key].value == "0")
    ) {
      continue;
    }

    let errorRetObj = validateField(
      validationType,
      inputValue,
      isRequired,
      defaultMsg,
      extraParamsObj
    );

    formValueCloneObj[key].error = errorRetObj.error;
    formValueCloneObj[key].message = errorRetObj.message;
    formValueCloneObj[key].touched = true;

    if (errorRetObj.error == true) {
      valid = false;
    }
  }

  if (valid == false) {
    setFormValues(formValueCloneObj);
  }
  return valid;
};
export const isFormValidForMultiple = (
  formValuesArr,
  setFormValues,
  specificCheck,
  extraParamsObj
) => {
  let formValueCloneObj = cloneDeep(formValuesArr);
  let valid = true;

  for (let i = 0; i < formValuesArr.length; i++) {
    let formValues = formValuesArr[i];
    for (let key in formValues) {
      if (
        key == "IsTargetingSetAdded" ||
        key == "TargetingSets" ||
        key == "isDeleted"
      ) {
        continue;
      }
      if (
        specificCheck != null &&
        specificCheck != undefined &&
        specificCheck.length > 0
      ) {
        if (!specificCheck.includes(key)) {
          continue;
        }
      }
      let validationType = formValues[key].type;
      let inputValue = formValues[key].value;
      let isRequired = formValues[key].required;
      let defaultMsg = formValues[key].default_msg;

      let errorRetObj = validateField(
        validationType,
        inputValue,
        isRequired,
        defaultMsg,
        extraParamsObj
      );
      formValues[key].error = errorRetObj.error;
      formValues[key].message = errorRetObj.message;
      formValues[key].touched = true;
      if (errorRetObj.error == true) {
        valid = false;
      }
    }

    formValueCloneObj[i] = formValues;
  }

  if (valid == false) {
    setFormValues(formValueCloneObj);
  }
  return valid;
};
export const inputBlurHandler = (
  e,
  formValues,
  setFormValues,
  extraParamsObj
) => {
  e.preventDefault();
  let inputName = e.target.name;
  let validationType = formValues[inputName].type;

  // console.log("FormInput-Value:", formValues[inputName].value);
  let inputValue =
    formValues[inputName].value != "" &&
    formValues[inputName].value != null &&
    formValues[inputName].value != undefined &&
    typeof formValues[inputName].value == "string"
      ? formValues[inputName].value.trim()
      : formValues[inputName].value;
  let isRequired = formValues[inputName].required;
  let defaultMsg = formValues[inputName].default_msg;

  let errorRetObj = validateField(
    validationType,
    inputValue,
    isRequired,
    defaultMsg,
    extraParamsObj
  );

  setFormValues((prevState) => ({
    ...prevState,
    [inputName]: {
      ...prevState[inputName],
      error: errorRetObj.error,
      message: errorRetObj.message,
      touched: true,
      value: inputValue,
    },
  }));
};

export const validateField = (
  validationType,
  value,
  isRequired,
  defaultMsg,
  extraParamsObj
) => {
  let retObj = { error: false, message: "" };

  if (isRequired === false && (value == "" || value == null)) {
    return retObj;
  } else {
    switch (validationType) {
      case undefined:
        return retObj;

      case "email":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Email Address";
        } else if (!validateEmail(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid Email Address (user@example.com)";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "username":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Username";
        } else if (value.length < 4) {
          retObj.error = true;
          retObj.message = "Enter Username with minimum 4 characters";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "password":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Password";
        } else if (value.length < 6) {
          retObj.error = true;
          retObj.message = "Enter Password with minimum 6 characters";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;

      case "url":
        if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = "Enter Url";
        } else if (!ValidURL(value)) {
          retObj.error = true;
          retObj.message = "Enter Valid URL";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;
      case "radio":
        retObj.error = false;
        retObj.message = "";
        return retObj;
      case "goal":
        retObj.error = false;
        retObj.message = "";
        return retObj;
      case "percentage":
        if (value == "0") {
          retObj.error = false;
          retObj.message = "";
        } else if (value == "" || value == null) {
          retObj.error = true;
          retObj.message = defaultMsg;
        } else if (value > 100 || value < 0) {
          retObj.error = true;
          retObj.message = "The Percentage value should be in between 0 to 100";
        } else {
          retObj.error = false;
          retObj.message = "";
        }
        return retObj;
      case "zero":
        retObj.error = false;
        retObj.message = "";
        return retObj;

      default:
        if (value == "" || value == null || value == false) {
          retObj.error = true;
          retObj.message = defaultMsg;
        }
        return retObj;
    }
  }
};

export const searchObjFromArrayOfObjs = (source, searchObj) => {
  const res = find(source, searchObj);
  return res;
};

export const selectChangeHandler = (e, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;
  setFormValues((prevState) => ({
    ...prevState,
    [inputName]: {
      ...prevState[inputName],
      value: inputValue,
      touched: true,
      error: inputValue == "" ? true : false,
      message: inputValue != "" ? "" : prevState[inputName]["default_msg"],
    },
  }));
};

export const multiSelectChangeHandler = (e, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;

  setFormValues((prevState) => ({
    ...prevState,
    [inputName]: {
      ...prevState[inputName],
      value: inputValue,
      touched: true,
      error: inputValue == "" ? true : false,
      message: inputValue != "" ? "" : prevState[inputName]["default_msg"],
    },
  }));
};
export const multiCheckBoxChangeHandler = (e, setFormValues) => {
  let inputName = e.target.name;
  let inputValue =
    e.target.value != undefined &&
    e.target.value != null &&
    typeof e.target.value == "string"
      ? e.target.value.trim()
      : e.target.value;
  let previewsValue =
    e.target.previewsValue != undefined && e.target.previewsValue != null
      ? e.target.previewsValue
      : [];

  let checked = e.target.checked;

  if (checked) {
    //   Add
    previewsValue.push(inputValue);
  } else {
    // Remove
    const index = previewsValue.indexOf(inputValue);
    if (index > -1) {
      // only splice array when item is found
      previewsValue.splice(index, 1); // 2nd parameter means remove one item only
    }
  }
  // setFormValues((prevState) => ({
  //   ...prevState,
  //   [inputName]: {
  //     ...prevState[inputName],
  //     value: [],
  //     touched: true,

  //   },
  // }));
  setFormValues((prevState) => ({
    ...prevState,
    [inputName]: {
      ...prevState[inputName],
      value: previewsValue,
      touched: true,
      error: inputValue?.length <= 0 ? true : false,
      //message: inputValue != "" ? "" : prevState[inputName]["default_msg"],
    },
  }));
  //console.log("State UUU");
};
export const ValidURL = (str) => {
  var regex =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
};

export const checkAudienceSelected = (selectedSegmentsObj, provider) => {
  let hasData = false;

  if (provider != "" && provider != null && provider != undefined) {
    let groupsKeysList = Object.keys(selectedSegmentsObj?.[provider]);
    if (groupsKeysList.length > 0) {
      for (let k = 0; k < groupsKeysList.length; k++) {
        if (selectedSegmentsObj[provider][groupsKeysList[k]].length > 0) {
          hasData = true;
          break;
        }
      }
    }
  } else {
    for (let pdr in selectedSegmentsObj) {
      let groupsKeysList = Object.keys(selectedSegmentsObj[pdr]);
      if (groupsKeysList.length > 0) {
        for (let k = 0; k < groupsKeysList.length; k++) {
          if (selectedSegmentsObj[pdr][groupsKeysList[k]].length > 0) {
            hasData = true;
            break;
          }
        }
      }
    }
  }
  return hasData;
};

export const EmailFormValidation = (emailStr = "") => {
  let emailArr = emailStr.split(",");
  let validate = true;
  if (emailArr.length > 0) {
    emailArr.map((email) => {
      if (
        email == "" ||
        email == null ||
        email == undefined ||
        (email != "" && !validateEmail(email))
      ) {
        validate = false;
      }
    });
  }
  return validate;
};

export const sortArrayOfObjectsByProperty = (
  array,
  property,
  order = "asc"
) => {
  // Sorting the array of objects based on the specified property
  array.sort((a, b) => {
    if (order === "asc") {
      if (a[property] < b[property]) return -1;
      if (a[property] > b[property]) return 1;
    } else if (order === "desc") {
      if (a[property] > b[property]) return -1;
      if (a[property] < b[property]) return 1;
    }
    return 0; // If 'a' and 'b' are equal
  });

  return array;
};

export const getTargetingLabelByValue = (array, value) => {
  //console.log("value SIIID:", value);
  const foundObject = array.find((item) => item.value == value);
  return foundObject ? foundObject.label : null; // return the label or null if not found
};
